export const ToggleSidebar = (showPanel) => {
    return {
        type: "SIDE_BAR",
        showPanel,
    };
};

export const RadioValue = (radioValue) => {
    return {
        type: "RADIO_VALUE",
        radioValue,
    };
};

export const CheckBoxValue = (switchCheckBox, label) => {
    return {
        type: "CHECK_BOX",
        switchCheckBox,
        label,
    };
};

export const selectTableItems = (selectedIds,name) => {
    return {
        type: "SELECT_TABLE_ITEMS",
        selectedIds,
        name
    };
};

export const setPagination = (pagination) => {
    return {
        type: "SET_PAGINATION",
        pagination,
    };
};

export const tabActiveKey = (valueTabActiveKey) => {
    return {
        type: "VALUE_TAB_ACTIVE_KEY",
        valueTabActiveKey,
    };
};
